export default {
  'TITLE_TAB': 'Campañas WiFi',
  'ENTITY_NAME': 'Campaña',
  'CREATE_CAMPAIGN_TITLE': 'Crear Campaña WiFi',
  'EDIT_CAMPAIGN_TITLE': 'Editar campaña publicitaria',
  'CREATE_CAMPAIGN_SUBMIT_BUTTON_TEXT': 'Confirmar',
  'EDIT_CAMPAIGN_SUBMIT_BUTTON_TEXT': 'Guardar',
  'MALE': 'Masculino',
  'FEMALE': 'Femenino',
  'BOTH': 'Ambos',
  'CAMPAIGN_TYPE': 'Formato de campaña WiFi',
  'FORMS_INPUTS': {
    'NAME': 'Nombre de campaña',
    'REDIRECT': 'Página web de redirección',
    'PLACEMENT': 'Sitio',
    'GENDER': 'Género',
    'START_DATE': 'Fecha de inicio',
    'START_TIME': 'Hora de inicio',
    'END_DATE': 'Fecha de término',
    'END_TIME': 'Hora de término',
    'MIN_AGE': 'Edad mínima',
    'MAX_AGE': 'Edad máxima',
  },
  'THUMBNAIL': {
    'TITLE': 'Imagen miniatura de Campaña',
    'TEXT': 'Subir para desplegar en la etapa de selección de Campañas',
  },
  'TYPE_INPUT': {
    'TYPE': 'Tipo de Campaña',
    'VIDEO': 'Video',
    'IMAGE': 'Imagen',
    'FORM': 'Encuesta',
  },
  'TABLE_HEADERS': {
    'NAME': 'Nombre',
    'START_DATE': 'Inicio',
    'END_DATE': 'Finalización',
    'STATUS': 'Estado',
  },
  'CAMPAIGN_STATUS': {
    'ACTIVE': 'Activa',
    'FINISHED': 'Finalizada',
    'PAUSED': 'Pausada',
  },
  'FORM_VALIDATION': {
    'REQUIRED': 'Obligatorio',
    'NAME_FEEDBACK': 'Los caracteres aceptados incluyen letras minúsculas y mayúsculas, dígitos y símbolos especiales tales como -+#_,!¡¿?&.',
    'THUMBNAIL_FEEDBACK': 'Tamaño del archivo debe ser menor a 2MB',
    'DATE_FEEDBACK': 'Formato de fecha incorrecto',
    'TIME_FEEDBACK': 'Formato de tiempo incorrecto',
    'MIN_AGE_FEEDBACK': 'Edad mínima debe ser un número',
    'MAX_AGE_FEEDBACK': 'Edad máxima debe ser un número',
    'MAX_AGE_FEEDBACK_2': 'Edad máxima debe ser mayor a edad mínima',
    'VIDEO_FEEDBACK': 'Corto',
    'QUESTIONS_FEEDBACK': 'Debes tener por al menos una pregunta',
    'END_DATE': 'Fecha de finalización debe ser mayor a la de inicio',
  },
  'IMAGE_UPLOADER': {
    'TITLE': 'Una imagen para subir',
    'IMAGE_UPLOAD_ERROR': 'No podemos subir la imagen',
  },
  'VIDEO_UPLOADER': {
    'TITLE': 'Recomendación: suba un video cuya duración sea no mayor a 20 segundos. El máximo permitido es 1 minuto',
    'VIDEO_LABEL': 'Archivo de video cargado',
    'BUTTON_UPLOAD_TEXT': 'Subir video',
    'BUTTON_PREVIEW_TEXT': 'Vista previa',
    'UPLOADING': 'Subiendo video...',
    'VIDEO_UPLOAD_ERROR': 'No podemos subir el video',
    'VIDEO_CODE_REQUIRED': 'Código de video requerido',
    'INVALID_VIDEO_CODE': 'Código de video {{ code }} inválido',
    'VIDEO_TIME_TOO_LONG': 'Duración máxima del video es de {{ time }} segundos',
    'VIDEO_SIZE_TOO_LARGE': 'Tamaño máximo del video es de {{ size }} MB',
  },
  'YOUTUBE_UPLOADER': {
    'TITLE': 'Recomendación: ingrese un enlace a un video de YouTube cuya duración sea no mayor a 20 segundos. El maximo permitido es 1 minuto',
    'IMAGE_LABEL': 'Archivo de imagen cargado',
    'VIDEO_LABEL': 'Link de video de YouTube',
    'VIDEO_LABEL_EDIT_MODE': 'Archivo de video cargado',
    'BUTTON_TEXT': 'Subir video de YouTube',
    'VIDEO_UPLOAD_ERROR': 'No podemos subir el video',
    'VIDEO_CODE_REQUIRED': 'Código de video requerido',
    'INVALID_VIDEO_CODE': 'Código de video {{ code }} inválido',
    'VIDEO_LENGTH_TOO_LONG': 'Duración máxima del video es de {{ count }} minuto',
    'VIDEO_LENGTH_TOO_LONG_plural': 'Duración máxima del video es de {{ count }} minutos',
  },
  'QUESTIONNAIRE': {
    'BUTTON_TEXT': 'Añadir pregunta',
    'MODAL_TITLE': 'Añadir pregunta',
    'MODAL_CANCEL_BUTTON': 'Cancelar',
    'MODAL_NEXT_BUTTON': 'Seguir',
    'QUESTION_CANCEL_BUTTON': 'Cancelar',
    'QUESTION_SAVE_BUTTON': 'Guardar',
    'SINGLE_CHOICE_QUESTION': 'Pregunta con una sola opción a elegir',
    'MULTIPLE_CHOICE_QUESTION': 'Pregunta con múltiples opciones a elegir',
    'OPEN_QUESTION': 'Pregunta abierta',
    'RATING_QUESTION': 'Pregunta con calificación',
    'QUESTION_PLACEHOLDER': 'Pregunta',
    'QUESTION_OPTIONS': 'Opciones',
    'NEW_OPTION': 'Nueva opción',
    'ADD_OPTION': '+ Añadir opción',
    'QUESTION_OPTIONS_RATING_QUESTION': 'Opciones: formato de visualización',
    'EMPTY_QUESTION_ERROR': 'La pregunta tiene que tener el nombre',
    'EMPTY_OPTIONS_ERROR': 'Debes añadir al menos una opción'
  },
}
